import { Box, Center, Image, Text } from '@chakra-ui/react'
import React from 'react'
// import { CheckCircleIcon } from '@chakra-ui/icons';
import { PospImages } from 'Assets/Posp'

const Stepper = (props: any) => {
  const { showAfter, isCompleated, stepName, isActive } = props
  return (
    <>
      <Box border='none'>
        <Box
          background={
            isCompleated || isActive
              ? '#64BCFC 0% 0% no-repeat padding-box'
              : '#EDEDED 0% 0% no-repeat padding-box;'
          }
          // border={isCompleated ? '1px solid #366B9E' : ''}
          color={isCompleated || isActive ? '#FFFFFF' : '#AAA9A9'}
          padding={2}
          width={150}
          position='relative'
        >
          {isCompleated && (
            <span style={{ position: 'absolute', left: '-5%', zIndex: 10 }}>
              <Image src={PospImages.CheckmarkIcon} />
            </span>
          )}

          <Center
            _after={
              showAfter && {
                top: '100%',
                content: '""',
                display: 'block',
                position: 'absolute',
                height: '30px',
                borderLeft: '1px solid #00548C',
                rotate: '90deg',
              }
            }
          >
            {stepName}
          </Center>
        </Box>
      </Box>
    </>
  )
}
export const MobileStepper = (props: any) => {
  const { showAfter, isCompleated, stepName, isActive } = props

  return (
    <Box
      height='30px'
      bg={isCompleated ? '#64BCFC' : isActive ? '#E6F5FF' : 'white'}
      position='relative'
    >
      <Text py='8px'  position='absolute' w='full' zIndex={45} align='center' fontSize='9px'>
        {stepName}
      </Text>
      {isActive && (
        <>
          <Box position='absolute' h='full' top='0.5' right='1.5' zIndex={40} background='transparent'>
            <Box w='28px' h='26px' transform='rotate(45deg)' borderTop='1px solid #fff' borderRight='1px solid #fff'></Box>
          </Box>
          <Box right={-1} top={0} position='absolute' h='full' w={6} bg='white' zIndex={30}></Box>
          <Box zIndex='40' position='absolute' top='2px' right='3px'>
            <Box
              bg='#E6F5FF'
              w='28px'
              h='26px'
              transform='rotate(45deg)'
              borderTop='1px solid #dfdfdf' borderRight='1px solid #dfdfdf'
            ></Box>
          </Box>
        </>
      )}
    </Box>
  )
}

export default Stepper
